import {Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class LoginType implements Parameter {
	public user?: string;
	public password?: string;

	constructor(data: any) {
		this.user = FunctionHelper.exists(data?.user) ? data.user : "";
		this.password = FunctionHelper.exists(data?.password) ? data.password : "";
	}

	public static getUserDefault(): string {
		return "";
	}

	public static getPasswordDefault(): string {
		return "";
	}

	public static fromJson(data: any): LoginType {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new LoginType(data);
	}

	public toJson(): any {
		return {
			'user': this.user,
			'password': this.password
		};
	}

	public clone(): LoginType {
		return LoginType.fromJson(this.toJson());
	}
}